// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Grid from '@mui/material/Grid';
import {
    Divider,
    IconButton,
    Tooltip,
    Fab
} from '@mui/material'
import axios from 'axios'
import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useToast } from '../../../components/ToastProvider'
import DialogMemoAdd from '../../../components/acc/DialogMemoAdd';

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State
    const [tabs, setTabs] = useState<string>("0")
    const [listData, setListData] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [dialogMode, setDialogMode] = useState<'add' | 'edit'>('add')
    const [selectedData, setSelectedData] = useState<any>(null)

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        setListData([])
        let url = apiUrl.apiUrl + '/acc/memo-ar/list'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getDetail = (id: any) => {
        let url = apiUrl.apiUrl + '/acc/memo-ar/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    setDialogMode('edit')
                    setSelectedData(data)
                    setOpenDialog(true)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleDelete = (row: any) => {
        let url = apiUrl.apiUrl + '/acc/invoice/delete-memo/' + row.id
        axios
            .post(url, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getData()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData()
    }

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row)
            },
            {
                title: "Print",
                icon: "mdi:printer",
                color: "primary",
                // onClick: () => window.open(apiUrl.baseUrl + '/acc/dp-customer/pdf/' + row.id, '_blank')
            },
            {
                title: "Hapus",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(row: any) => {
                        getDetail(row.id)
                    }}
                />
            ),
        },
    ];

    const hiddenColumns = ['aktif','no_akun']

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='MEMO AR' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab
                                color='primary'
                                size='medium'
                                onClick={() => {
                                    setDialogMode('add')
                                    setSelectedData(null)
                                    setOpenDialog(true)
                                }}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Semua Memo' />
                        </TabList>
                        <TabPanel value='0'>
                            <MsiDatagrid array={listData} actions={actionData} hiddenColumns={hiddenColumns} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>

            <DialogMemoAdd
                key={selectedData?.id ?? 'add'}
                open={openDialog}
                mode={dialogMode}
                data={selectedData}
                onClose={() => {
                    setOpenDialog(false)
                    getData()
                }}
            />

        </Grid>
    )
}
